import { hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";
import App from "../app";

const appData = window.asos.gpc.state;
delete window.asos.gpc.state;

const { storeData } = appData;

const start = async () => {
  loadableReady(() => {
    hydrateRoot(
      document.getElementById("react-root"),
      <App storeData={storeData} />
    );
  });
};

start();
